import { useEffect, useRef, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import {
  clearProductInterval,
  setProductInterval,
} from "@/utils/productTimers";

export default function FpProgressBar({ runForSec, type }) {
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);

  const progressRef = useRef(() => {});
  const bufferRef = useRef(() => {});
  const maxProgress = 95;
  const maxBuffer = 98;

  useEffect(() => {
    progressRef.current = () => {
      setProgress((oldProgress) => {
        if (oldProgress >= maxProgress) {
          return maxProgress;
        }

        const increment = Math.floor(Math.random() * 10) + 1;
        const newProgress = oldProgress + increment;

        return newProgress > maxProgress ? maxProgress : newProgress;
      });
    };

    bufferRef.current = () => {
      setBuffer((oldBuffer) => {
        if (oldBuffer >= maxBuffer) {
          return maxBuffer;
        }

        const increment = Math.floor(Math.random() * 10) + 1;
        const newBuffer = oldBuffer + increment;

        return newBuffer > maxBuffer ? maxBuffer : newBuffer;
      });
    };
  }, []);

  useEffect(() => {
    const intervalTime = (runForSec * 1000) / maxProgress;
    const timer = setProductInterval(() => {
      progressRef.current();
      bufferRef.current();
    }, intervalTime);

    return () => {
      clearProductInterval(timer);
    };
  }, [runForSec]);

  return type === "buffer" ? (
    <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
  ) : (
    <LinearProgress variant="determinate" value={progress} />
  );
}
